import React from 'react';

import { STEPS } from '../../constants';
import { useStyles } from './Stepper.styles';

interface StepperProps {
  currentStep: number;
  /**
   * Optional custom steps array. If not provided, defaults to STEPS from constants.
   * Use OTP_STEPS.NEW_USER for 3-step flow or OTP_STEPS.RETURNING_USER for 2-step flow.
   */
  steps?: readonly string[] | string[];
}

export function Stepper({ currentStep, steps = STEPS }: StepperProps): JSX.Element {
  const s = useStyles();

  return (
    <div className={s.stepper}>
      {steps.map((label, index) => (
        <div key={label} className={s.stepContainer}>
          <div className={s.step}>
            <div
              className={`${s.stepCircle} ${
                index <= currentStep ? s.stepCircleActive : s.stepCircleInactive
              }`}
            >
              {index < currentStep ? (
                <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                index + 1
              )}
            </div>
            <span
              className={`${s.stepLabel} ${
                index <= currentStep ? s.stepLabelActive : s.stepLabelInactive
              }`}
            >
              {label}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`${s.stepConnector} ${
                index < currentStep ? s.stepConnectorActive : s.stepConnectorInactive
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
}

export default Stepper;
